import React, { memo, useCallback, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { Center, Text, VStack } from '@chakra-ui/react'
import { faRotateRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { usePagination, useTable } from 'react-table'
import CustomCell from '../TableCells/CustomCell/CustomCell'
import TableUI from '../TableUI'

const defaultColumn = {
  Cell: CustomCell,
}
const TableLocal = ({
  columns,
  data,
  updateMyData,
  onSort = () => null,
  onEmployeeClick = () => null,
  orderBy,
  orderAsc,
  pagination,
  tableStyles,
}) => {
  const [actualPage, setActualPage] = useState(1)

  const {
    // canPreviousPage,
    // canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    // nextPage,
    // previousPage,
    state: { pageIndex },
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      updateMyData,
      onEmployeeClick,
      autoResetPage: false,
      initialState: { pageSize: 10, indexPage: actualPage },
    },
    usePagination,
  )

  const handlePageChange = useCallback(
    (newPage) => {
      const indexPage = newPage - 1
      gotoPage(indexPage)
      setActualPage(newPage)
    },
    [gotoPage, pageCount],
  )

  const paginationProps = useMemo(() => {
    const actualPage = pageIndex ? pageIndex + 1 : 1
    return {
      totalPages: pageOptions ? pageOptions?.length : 0,
      actualPage: actualPage,
      handlePageChange,
    }
  }, [pageOptions, pageIndex, pagination, data])

  const tableProps = useMemo(
    () => ({
      getTableProps,
      getTableBodyProps,
      headerGroups,
      page,
      prepareRow,
      withPagination: true,
      paginationProps,
    }),
    [
      pageIndex,
      pageOptions,
      getTableProps,
      page,
      getTableBodyProps,
      headerGroups,
      prepareRow,
      handlePageChange,
      paginationProps,
    ],
  )

  return (
    <VStack spacing={0} width="100%">
      <TableUI
        withSort
        onSort={onSort}
        {...{ orderBy, orderAsc }}
        isLocalPaginated
        {...tableProps}
        tableStyles={tableStyles}
      />
      {!data?.length && (
        <Center border="1px solid rgb(215, 215, 215)" w="100%" h="143px">
          <VStack>
            <FontAwesomeIcon size="2x" icon={faRotateRight} />
            <Text>no hay datos para mostrar</Text>
          </VStack>
        </Center>
      )}
    </VStack>
  )
}

TableLocal.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
  onEmployeeClick: PropTypes.func,
  onSort: PropTypes.func,
  orderAsc: PropTypes.bool,
  orderBy: PropTypes.string,
  pagination: PropTypes.shape({
    actualPage: PropTypes.number,
  }),
  updateMyData: PropTypes.func,
  tableStyles: PropTypes.object,
}

export default memo(TableLocal)
